<section class="main">
  <section id="capture" #screen>
    <div class="text-center">
      <h4 class="mb-1">Gate Pass</h4>
      <h4 class="">One Use Pass</h4>
    </div>
    <div class="mt-4 d-flex justify-content-between align-items-center">
      <div class="divOne">
        <h4 class="mb-1">Vistor</h4>
        <p >{{clientName | uppercase }}</p>
        <!-- <p>ahmed</p> -->
      </div>
      <div class="divtow text-right">
        <h4 class="mb-1">Inviter</h4>
        <!-- <p>ahmed el shaari</p> -->
        <p>{{clientInviter | uppercase}}</p>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="divOne">
        <h4 class="mb-1">Unit</h4>
        <p>{{unitname | uppercase}}</p>
        <!-- <p>Marasii Vitonia p1</p> -->
      </div>
      <div class="divtow text-right">
        <h4 class="mb-1">Date</h4>
        <p>{{ date | date: "mediumDate" }}</p>
      </div>
    </div>
    <div class="text-center">
      <ngx-qrcode
        [elementType]="elementType"
        [errorCorrectionLevel]="correctionLevel"
        [value]="value"
        cssClass="bshadow"
        [width]="160"
      ></ngx-qrcode>
    </div>
  </section>
  <div class="text-center mt-3">
    <button class="btn" (click)="dowenload()">Dowenload</button>
  </div>
  <div id="download"style="padding: 10px ; display: none">
      <img #canvas >
      <a #downloadLink></a>
    </div>
</section>
